import React from 'react';
import './RadioButton.scss';

function RadioButton({name, checked, onChange}) {
  return (
    <label htmlFor={name} className='prequal--web--customRadioButton-fomo'>
      <input type='radio' data-testid={`radioButton-${name}`} name={name} value={name} checked={checked} onChange={onChange} />
      <span>{name}</span>
    </label>
  );
}

export default RadioButton;
